

<div class="row g-0 h-100 pt-4" style="user-select: none !important;">
  <div class="h-100" [ngStyle]="tablesStyles.books">
    <div class="row g-0 justify-content-center">
      <h2 style="width: auto; color:#f2c63d">Lista de Books</h2>
    </div>
    <div class="row g-0 justify-content-center mb-3">
      <div class="row g-0 justify-content-start mb-3">
        <div class="col-auto me-4">
          
        </div>
        <div class="col-auto me-4">
          <span class="pe-3 d-inline">Estudio: </span>
          <input type="text" #StudySearchTerm class="form-control d-inline" style="width: 200px;">
        </div>

        <div class="col-auto me-4">
          <span class="pe-3 d-inline">Paciente: </span>
          <input type="text" #PatientSearchTerm class="form-control d-inline" style="width: 200px;">
        </div>
        
        
      </div>
      
    </div>
    <table mat-table [dataSource]="studyList" class="table" matSort cdkDropList cdkDropListOrientation="horizontal"
        multiTemplateDataRows>
      
      <ng-container matColumnDef="PatientName">
        <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag mat-sort-header>Paciente</th>
        <td mat-cell *matCellDef="let study">
          <span>{{study.patientName}}</span>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="StudyDate">
        <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag mat-sort-header>Fecha Estudio</th>
        <td mat-cell *matCellDef="let study">
          <span>
            {{study.studyDate | date:'dd/MM/yyy - HH:mm'}}
          </span>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="StudyDescription">
        <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag mat-sort-header>Descripción</th>
        <td mat-cell *matCellDef="let study">
          <span>
            {{study.studyDescription}}
          </span>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef cdkDragLockAxis="x" cdkDrag>Acciones
        </th>
        <td mat-cell *matCellDef="let study">
          <div *ngIf="study!=null && study.id!=null">
            <span class="prp-icons icon-see"
              (click)="$event.stopPropagation();onClickOpenVisor(study)" style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
              title="Abrir estudio" [class.disabled]="!study.hasDCMs">
            </span>
            
            <span *ngIf="downloading!=null && downloading.studyUID==study.studyUID; else DownloadIcon" 
              style="font-size: 12px; cursor: pointer; color: #f2c63d; display: inline-block; width: 30px; text-align: center;"
              title="Descargando...">
              {{downloading.percentage | number:'1.0'}}%
            </span>
            <ng-template #DownloadIcon>
              <span class="visor-icons icon-download" title="Descargar estudio"
                (click)="$event.stopPropagation();onClickDownloadStudy(study);"
                style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
                [class.disabled]="!study.hasDCMs">
              </span>
            </ng-template>

            <span class="prp-icons icon-pdf" title="Informes"
              (click)="$event.stopPropagation();onClickOpenReportPreview(study);"
              style="cursor: pointer; display: inline-block; width: 30px; text-align: center;"
              [class.disabled]="!study.hasReports">
            </span>

            <span class="visor-icons icon-info clickable" (click)='onClickStudiesQuery(study)'
              title='Estudios del paciente' style="display: inline-block; width: 30px; text-align: center;"></span>

            <span class="ps-icons icon-book-digital clickable" (click)='onClickSeeBook(study)'
              title='Ver Book' style="display: inline-block; width: 30px; text-align: center;" [class.disabled]="!study.hasAccessibleBook"></span>
          </div>
        </td>
        
      </ng-container>
      

      <tr mat-header-row *matHeaderRowDef="displayedColumns">
      </tr>
      <tr mat-row *matRowDef="let study; columns: displayedColumns;">
      </tr>
      
    </table>

    <div class='w-100 h-50 d-flex justify-content-center align-items-center'
      style="background-color: rgba(128, 128, 128, 0.192);" *ngIf='isStudyListEmpty'>
      <div class="d-flex justify-content-center w-100">
        <h4>No se han encontrado estudios</h4>
      </div>
    </div>

    <div class="d-flex justify-content-between p-2 float-right col-md">
      <ngb-pagination [collectionSize]="totalStudies" [(page)]="pageStudies" [pageSize]="pageSize" [boundaryLinks]="true"
        [maxSize]="10" (pageChange)="onPageChange($event)">
    </ngb-pagination>
    
      <select class="table-select" style="width: auto" name="pageSize" [(ngModel)]="pageSize"
        (change)="onPageChange(null)">
        <option [ngValue]="4">4 por página</option>
        <option [ngValue]="8">8 por página</option>
        <option [ngValue]="10">10 por página</option>
        <option [ngValue]="14">14 por página</option>
        <option [ngValue]="18">18 por página</option>
      </select>
    </div>
  </div>

</div>

<!--<app-download-study-modal></app-download-study-modal>-->
<app-study-historic-modal></app-study-historic-modal>
<app-report-viewer></app-report-viewer>

